import { render, staticRenderFns } from "./ComparativoVentasFacturas.vue?vue&type=template&id=1c159f38&scoped=true"
import script from "./ComparativoVentasFacturas.vue?vue&type=script&lang=js"
export * from "./ComparativoVentasFacturas.vue?vue&type=script&lang=js"
import style0 from "./ComparativoVentasFacturas.vue?vue&type=style&index=0&id=1c159f38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c159f38",
  null
  
)

export default component.exports